export default {
  colors: {
    pieChart: {
      primary: "#3E89B4",
      secondary: "#AD1E1E",
    },
    background: {
      white: "#FAFAFA",
      primary: "#F5F8FA",
      bgModal: "#00000050",
    },
    blue: {
      pressing: "#004D8C",
      focus: "#5CC4E8",
      primary: "#3E89B4",
      medium: "#3477AE",
      light: "#EDF7FF",
    },
    gray: {
      100: "#FAFAFA",
      200: "#F2F2F2",
      300: "#757575",
      400: "#616161",
      500: "#807E80",
      600: "#424242",
      700: "#9197B3",
      900: "#1A191A",
    },

    button: {
      primary: "#04518A",
      medium: "#3E89B4",
      light: "#D8E9F3",
      disabled: "#C2C2C2",
      dark: "#1E4484",
      cinza: "#F6F6F6",
    },

    alertDialog: {
      success: {
        primary: "#51C68C",
        medium: "#51C68C",
        light: "#edf7ed",
      },
      warning: {
        primary: "#ec9315",
        medium: "#ffcc00",
        light: "#fff4e5",
      },
      error: {
        primary: "#DC2626",
        medium: "#dc2626",
        light: "#F7E4E4",
      },
    },

    white: "#fff",

    attention: "#DC2626",
    alert: "#ffa500",
    succesful: "#51C68C",
  },

  shadow: {
    default:
      "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  },
};
